import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "../app/globals.css";
import { MultitrackVocalMidiStudio } from "../app/MultitrackVocalMidiStudio";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Native app root was not found.");
}

createRoot(root).render(
  <StrictMode>
    <MultitrackVocalMidiStudio />
  </StrictMode>,
);
